import { buildServiceUrl } from "../urlBuilder";

const KEYCLOAK_REALM_URL = buildServiceUrl("keycloak", "/realms/DSB", {
  useRuntimePort: false,
});
const KEYCLOAK_WELL_KNOWN_URL = `${KEYCLOAK_REALM_URL}/.well-known/openid-configuration`;
const KEYCLOAK_CHECK_TIMEOUT_MS = 4000;

export async function checkKeycloakAvailability() {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(
    () => controller.abort(),
    KEYCLOAK_CHECK_TIMEOUT_MS
  );

  try {
    const response = await fetch(KEYCLOAK_WELL_KNOWN_URL, {
      method: "GET",
      cache: "no-store",
      signal: controller.signal,
    });

    return response.ok;
  } catch (error) {
    console.error("Keycloak availability check failed", error);
    return false;
  } finally {
    window.clearTimeout(timeoutId);
  }
}
